
import { Vue, Component } from 'vue-property-decorator'
import SimpleTable from '@/components/busi/table/simple-table.vue'
import Tree from '@/components/busi/custom/tree.vue'
import util from '@/utils/busi/util'
import { schoolGradeSearch } from '@/api/baseinformation'
@Component({
  name: 'school-grade-manage',
  components: {
    SimpleTable,
    Tree
  }
})
export default class SchoolGradeManage extends Vue {
  private form: any = {
  }

  private loading = !1

  private tableData = {
    list: [],
    totalCount: 0
  }

  private columns = [{
    prop: 'studyName',
    label: '学习类型'
  },
  {
    prop: 'schoolName',
    label: '院校名称'
  },
  {
    prop: 'gradeCode',
    label: '年级代码'
  },
  {
    prop: 'gradeName',
    label: '年级名称'
  }]

  private pagination: any = {
    currentPage: 1,
    pageSize: 10
  }

  private async onQuery (pagination: any = null) {
    // do something
    this.loading = !0
    const form = util.trimForm(this.form)
    !pagination && (this.pagination.currentPage = 1)
    await schoolGradeSearch({
      ...form,
      ...pagination || this.pagination
    }).then((res: any) => {
      this.loading = !1
      this.tableData.list = res.object.list
      this.tableData.totalCount = res.object.totalCount
    }).catch((err: any) => {
      console.log('err', err)
      this.loading = !1
    })
  }

  private onReset () {
    this.form = {
    }
    this.onQuery()
  }

  private handleNodeClick (data: any) {
    this.form.schoolId = data.id
    this.onQuery()
  }

  mounted () {
    this.onQuery()
  }
}
